export const purple = '#df37f2';
